export { moveUciToObj } from './engine/uci.mjs';

export const flipPosition = position => position.split('/').map(row => [...row].reverse().join('')).reverse().join('/');
export const reverseFenOrientation = fen => {
  const [position, ...rest] = fen.split(' ');
  return [flipPosition(position), ...rest].join(' ');
};
export const parseFenFromUrl = fen => typeof fen === 'string' ? fen.replace(/[_+]/g, ' ').trim().replace(/\s+/g, ' ') : '';

export function validPlacement(position) {
  if (typeof position !== 'string') return false;
  const ranks = position.split('/');
  return ranks.length === 8 && ranks.every(rank => /^[prnbqkPRNBQK1-8]+$/.test(rank) &&
    [...rank].reduce((n, c) => n + (/\d/.test(c) ? Number(c) : 1), 0) === 8);
}

export const isTypingEvent = event => event.altKey || event.ctrlKey || event.metaKey ||
  event.target?.isContentEditable || Boolean(event.target?.closest?.('input, textarea, select, [contenteditable="true"], [data-ignore-keydown], [role="dialog"], [role="menu"]'));
